import { CreateAdminQuotePayload } from "@/core";
import { serviceHost } from "@/services";
import { useMutation } from "@tanstack/react-query";

const functionsService = serviceHost.getFunctionsService();

export const useCreateAdminQuote = () => {
  return useMutation({
    mutationFn: (payload: CreateAdminQuotePayload) =>
      functionsService.createAdminQuote(payload),
  });
};
